import { useMemo } from 'react'
import { some } from 'lodash-es'
import { UseQueryResult } from '@tanstack/react-query'

const useQueriesLoading = (queryResults: UseQueryResult[], flag = 'isLoading') =>
  useMemo(() => some(queryResults, [flag, true]), [queryResults])

export default useQueriesLoading
